import { Link } from 'react-router-dom';
import { useContent } from '../hooks/useSession';
import { search } from '../lib/curriculum';

/** Search overlay. Matches lesson titles, summaries, track names and full body text. */
export function SearchResults({ query }: { query: string }) {
  const content = useContent();
  const hits = search(content.tracks, query);

  return (
    <div className="vu-wrap">
      <div className="vu-kicker">Search</div>
      <h1 className="vu-h1" style={{ fontSize: 'var(--fs-h2)' }}>
        {hits.length === 0 ? 'No matches' : hits.length === 1 ? '1 lesson' : `${hits.length} lessons`}
        <span className="vu-muted" style={{ fontWeight: 400 }}> for “{query}”</span>
      </h1>

      {hits.length === 0 && (
        <p className="vu-lede">
          Nothing matched every word. Try fewer words, or a term a lesson would actually use —
          “photography”, “returns”, “festival”.
        </p>
      )}

      <div style={{ marginTop: 'var(--space-6)' }}>
        {hits.map(({ track, lesson }) => (
          <Link
            key={`${track.id}/${lesson.id}`}
            to={`/track/${track.id}/${lesson.id}`}
            className="vu-card vu-card-hover"
            style={{ display: 'block', marginBottom: 'var(--space-3)' }}
          >
            <div className="vu-kicker" style={{ marginBottom: 4 }}>{track.name}</div>
            <div className="vu-h3" style={{ fontSize: 'var(--fs-lg)' }}>{lesson.title}</div>
            <p className="vu-muted" style={{ margin: '4px 0 0', fontSize: 'var(--fs-sm)' }}>{lesson.summary}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
